import { Box, Text, Inline, Hidden, Heading } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { WrapperStyle } from './index.css'
import { useProductsContext } from '../../context/products'
import BaseLayout from '../../layout/base-layout'
import ProductCard from '../ProductCard'
import EmptyProduct from '../empty-product'

type Props = {}

const LeasesAndPayments = (props: Props) => {
  const { t } = useTranslation()
  const { products } = useProductsContext()
  const productsEmpty = products.length < 1
  const emptyProducts: number[] = [1, 2, 3]

  return (
    <BaseLayout title={t('b.usage.credits.title', 'Credit Usage')}>
      <Box
        className={WrapperStyle}
        paddingY={{ mobile: 'gutter', desktop: 'xlarge' }}
        paddingX={{ mobile: 'gutter', desktop: 'xxxlarge' }}
        display="flex"
        flexDirection="column"
        gap="gutter"
      >
        <Box flexDirection="column" display="flex" gap="xxsmall">
          <Hidden below="tablet">
            <Heading level="4">
              {t('b.usage.credits.lease_payments.title', 'Lease and Payments')}
            </Heading>
          </Hidden>
          <Text tone="secondary" baseline={false} size="small">
            {t(
              'b.usage.credits.my_products.subtitle',
              'Easily unlock additional features for your listings, ready to use whenever you need them.'
            )}
          </Text>
        </Box>
        <Inline space="gutter">
          {productsEmpty
            ? emptyProducts.map((_, index) => <EmptyProduct key={`skeleton-card-lp-${index}`} />)
            : products
                .filter(product => product.tags.includes('lease-payments'))
                .map((product, index) => {
                  return <ProductCard key={product.key} product={product} />
                })}
        </Inline>
      </Box>
    </BaseLayout>
  )
}

export default LeasesAndPayments
